import React from "react"
import rating from "../../../images/reviews/rating.svg"
import quote from "../../../images/reviews/quote.svg"
import review_image from "../../../images/reviews/review_image.png"

function ReviewsCard() {
  return (
    <div className="w-full flex flex-col lg:flex-row gap-[50px] items-center ">
      <div className="w-full lg:w-[40%] ">
        <img src={review_image} alt="" />
      </div>
      <div className="w-full lg:w-[60%]">
        <div className="mb-10 mt-16 lg:mt-32">
          <img src={quote} alt="" />
        </div>
        <div className="mb-6">
          <img src={rating} alt="" />
        </div>
        <p className="w-full lg:w-[80%] text-[14px] lg:text-[16px]  italic text-[#222222] mb-16 ">
          "I couldn't be happier with the roofing services I received! The team
          was professional, efficient, and went above and beyond to ensure my
          roof was perfect. They communicated clearly throughout the process and
          left my property spotless. I highly recommend their services to anyone
          in need of roofing work."
        </p>

        <p className="font-[600]">SARAH M.</p>
      </div>
    </div>
  )
}

export default ReviewsCard
